import { useMutation } from '@tanstack/react-query'
import { useContext } from 'react'

import { signout } from '@src/api'
import { L_STORAGE_KEYS } from '@src/consts'
import { useCustomSnackbar } from '@src/hooks'
import { queryClient } from '@src/libs'
import { TfaTokenContext } from '@src/pages/_app.page'
import { lStorage, sleep } from '@src/utils'

import { OnSuccessArgs } from '../type'

export const useSignout = () => {
  const { openSnackbar } = useCustomSnackbar()
  const tfaTokenContext = useContext(TfaTokenContext)

  return useMutation({
    mutationFn: signout,
    onError: () => {
      window.location.href = '/signin'
    },
    onSuccess: async (
      _,
      { redirectUrl, backUrl, isSessionTimeout }: OnSuccessArgs
    ) => {
      lStorage.removeItem(L_STORAGE_KEYS.USER)
      lStorage.removeItem(L_STORAGE_KEYS.TOKEN)
      lStorage.removeItem(L_STORAGE_KEYS.MAIL_ADDRESS)
      lStorage.removeItem(L_STORAGE_KEYS.SMS_PHONE_NUMBER)
      const popupContents =
        lStorage.getItem(L_STORAGE_KEYS.NOTICED_CONTENTS) || '[]'
      const filteredContents = JSON.parse(popupContents).filter(
        (c: string) => c !== 'CARD_EXPIRY_NOTICE'
      )
      lStorage.setItem({
        key: L_STORAGE_KEYS.NOTICED_CONTENTS,
        value: JSON.stringify(filteredContents),
      })
      tfaTokenContext?.setTfaToken(null)
      tfaTokenContext?.setTfaTokenExpiresAt(null)
      if (isSessionTimeout) {
        openSnackbar(
          'セッションの有効期限が切れました。\nお手数ですが、再度ログインをお願いします。',
          'error'
        )
        await sleep({})
      }

      if (redirectUrl) {
        window.location.href = redirectUrl
      } else if (backUrl) {
        window.location.href = `/signin?backUrl=${backUrl}`
      } else {
        window.location.href = '/signin'
      }

      queryClient.invalidateQueries({
        refetchType: 'active',
      })
    },
  })
}
